import { render } from "./AppFooterMenu.vue?vue&type=template&id=3fadaad8&scoped=true"
import script from "./AppFooterMenu.vue?vue&type=script&lang=js"
export * from "./AppFooterMenu.vue?vue&type=script&lang=js"

import "./AppFooterMenu.vue?vue&type=style&index=0&id=3fadaad8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fadaad8"]])

export default __exports__